import { cn } from "@/lib/utils";

/** Reticle + forward-chevron mark, matching the favicon. */
export function Mark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden>
      <circle cx="32" cy="32" r="20" stroke="#1a2130" strokeWidth="2" />
      <circle
        cx="32"
        cy="32"
        r="20"
        stroke="#f4600f"
        strokeWidth="2"
        strokeDasharray="6 90"
        strokeDashoffset="-10"
      />
      <path
        d="M32 8V15 M32 49V56 M8 32H15 M49 32H56"
        stroke="#3a4458"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24 24L33 32L24 40"
        stroke="#f4600f"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34 24L43 32L34 40"
        stroke="#3fc8f0"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.85"
      />
    </svg>
  );
}

export function Wordmark({ className, markClass }: { className?: string; markClass?: string }) {
  return (
    <a href="#top" className={cn("group inline-flex items-center gap-2.5", className)}>
      <Mark className={cn("size-8 transition-transform duration-300 group-hover:rotate-90", markClass)} />
      <span className="font-display text-base font-bold tracking-tight text-ink-50">
        FWD<span className="text-signal-500">·</span>DEPLOYED
      </span>
    </a>
  );
}
